function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.43 27.42a3.43 3.43 0 113.43-3.43 3.42 3.42 0 01-3.43 3.43zm5.52-12.48a4.28 4.28 0 114.28-4.28 4.3 4.3 0 01-4.28 4.28zm0 25.81a3.43 3.43 0 110-6.86 3.435 3.435 0 110 6.87zM22.28 10.3a5.14 5.14 0 115.14-5.14 5.14 5.14 0 01-5.14 5.14zm0 36a3.43 3.43 0 113.43-3.43 3.42 3.42 0 01-3.43 3.43zm13.34-29.62a6 6 0 116-6 6 6 0 01-6 5.98zm0 24.1a3.43 3.43 0 113.43-3.48 3.43 3.43 0 01-3.43 3.46zm5.52-13.34a3.43 3.43 0 113.43-3.43 3.42 3.42 0 01-3.43 3.41z"
});

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 44.56 46.27"
  }, props), _ref);
};

export default SvgSpinner;